var _a, _b, _c;
import { t } from 'i18next';
export var Role;
(function (Role) {
    Role[Role["Superadmin"] = 0] = "Superadmin";
    Role[Role["Admin"] = 1] = "Admin";
    Role[Role["User"] = 2] = "User";
})(Role || (Role = {}));
export var UserType;
(function (UserType) {
    UserType[UserType["Planner"] = 1] = "Planner";
    UserType[UserType["Viewer"] = 2] = "Viewer";
})(UserType || (UserType = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["Active"] = "A";
    UserStatus["Inactive"] = "I";
})(UserStatus || (UserStatus = {}));
export var PlanType;
(function (PlanType) {
    PlanType["Monthly"] = "Monthly";
    PlanType["MonthlyCustom"] = "MonthlyCustom";
    PlanType["Weekly"] = "Weekly";
})(PlanType || (PlanType = {}));
export var PlanTypeCategory;
(function (PlanTypeCategory) {
    PlanTypeCategory["WorkVolume"] = "WorkVolume";
    PlanTypeCategory["ProdHours"] = "ProdHours";
})(PlanTypeCategory || (PlanTypeCategory = {}));
export var ActualInputMode;
(function (ActualInputMode) {
    ActualInputMode["Init"] = "init";
    ActualInputMode["Daily"] = "daily";
    ActualInputMode["Specific"] = "specific";
})(ActualInputMode || (ActualInputMode = {}));
export var Worktime;
(function (Worktime) {
    Worktime[Worktime["Deferrable"] = 1] = "Deferrable";
    Worktime[Worktime["NonDeferrable"] = 2] = "NonDeferrable";
})(Worktime || (Worktime = {}));
export var DifferenceMode;
(function (DifferenceMode) {
    DifferenceMode["Absolute"] = "Absolute";
    DifferenceMode["Percentage"] = "Percentage";
})(DifferenceMode || (DifferenceMode = {}));
export var MFAType;
(function (MFAType) {
    MFAType["TOTP"] = "SOFTWARE_TOKEN_MFA";
    MFAType["SMS"] = "SMS_MFA";
})(MFAType || (MFAType = {}));
export var MFAValidationType;
(function (MFAValidationType) {
    MFAValidationType[MFAValidationType["SecretKey"] = 0] = "SecretKey";
    MFAValidationType[MFAValidationType["QRCode"] = 1] = "QRCode";
})(MFAValidationType || (MFAValidationType = {}));
export var PlanColor = {
    0: { HColor: '#333366', CColor: '#D7E3F1' },
    1: { HColor: '#b25c03', CColor: '#f2d5b7' },
    2: { HColor: '#136a21', CColor: '#bce1c2' },
    3: { HColor: '#994f4f', CColor: '#e8cfd2' },
    4: { HColor: '#666633', CColor: '#e1e0cb' },
    5: { HColor: '#5c0276', CColor: '#dbd0f5' },
};
export var TABLE_HIERARCHY_COLORS = {
    lightBlue: '#D7E3F1',
    lightBlueGray: '#CBD4DE',
    lightGray: '#E3E7EB',
    lighterGray: '#F2F2F2',
    white: '#FFFFFF',
};
export var Currency;
(function (Currency) {
    Currency["Dollar"] = "$";
    Currency["Pound"] = "\u00A3";
    Currency["Euro"] = "\u20AC";
    Currency["Rupee"] = "\u20B9";
    Currency["Rand"] = "R";
})(Currency || (Currency = {}));
export var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["Dollar"] = "USD";
    CurrencyCode["Pound"] = "GBP";
    CurrencyCode["Euro"] = "EUR";
    CurrencyCode["Rupee"] = "INR";
    CurrencyCode["Rand"] = "ZAR";
})(CurrencyCode || (CurrencyCode = {}));
export var CURRENCY_SYMBOL = (_a = {},
    _a[CurrencyCode.Dollar] = '$',
    _a[CurrencyCode.Pound] = '£',
    _a[CurrencyCode.Euro] = '€',
    _a[CurrencyCode.Rupee] = '₹',
    _a[CurrencyCode.Rand] = 'R',
    _a);
export var KeyCurrency;
(function (KeyCurrency) {
    KeyCurrency["Dollar"] = "dollar";
    KeyCurrency["Pound"] = "pound";
    KeyCurrency["Euro"] = "euro";
    KeyCurrency["Rupee"] = "rupee";
    KeyCurrency["Rand"] = "rand";
})(KeyCurrency || (KeyCurrency = {}));
export var CURRENCY_CODE = (_b = {},
    _b[Currency.Dollar] = 'USD',
    _b[Currency.Pound] = 'GBP',
    _b[Currency.Euro] = 'EUR',
    _b[Currency.Rupee] = 'INR',
    _b[Currency.Rand] = 'ZAR',
    _b);
export var CognitoUserAttribute;
(function (CognitoUserAttribute) {
    CognitoUserAttribute["Email"] = "email";
    CognitoUserAttribute["EmailVerified"] = "email_verified";
    CognitoUserAttribute["PhoneNumber"] = "phone_number";
    CognitoUserAttribute["PhoneNumberVerified"] = "phone_number_verified";
})(CognitoUserAttribute || (CognitoUserAttribute = {}));
export var OrgType;
(function (OrgType) {
    OrgType["Cinareo"] = "Cinareo";
    OrgType["Genesys"] = "Genesys";
})(OrgType || (OrgType = {}));
export var IntegrationType;
(function (IntegrationType) {
    IntegrationType["Genesys"] = "genesys";
    IntegrationType["Aspect"] = "aspect";
})(IntegrationType || (IntegrationType = {}));
export var LIVE_INTEGRATION_TYPES = [IntegrationType.Genesys, IntegrationType.Aspect];
export var MetricTarget;
(function (MetricTarget) {
    MetricTarget["ServiceLevel"] = "SERVICE_LEVEL";
    MetricTarget["ASA"] = "ASA";
    MetricTarget["Occupancy"] = "OCCUPANCY";
})(MetricTarget || (MetricTarget = {}));
export var LocationType;
(function (LocationType) {
    LocationType["InHouse"] = "in_house";
    LocationType["Outsourced"] = "outsourced";
})(LocationType || (LocationType = {}));
export var StatusPermission;
(function (StatusPermission) {
    StatusPermission["Edit"] = "EDIT";
    StatusPermission["View"] = "VIEW";
    StatusPermission["Hide"] = "HIDE";
})(StatusPermission || (StatusPermission = {}));
// OrgConfigPermission shares the same EDIT/VIEW/HIDE values as StatusPermission.
// Aliased here so frontend code can reference OrgConfigPermission.Edit etc.
// and align with the backend entity/DTO name without duplicating the enum.
export var OrgConfigPermission = StatusPermission;
var STATUS_PERMISSION_PRIORITY = (_c = {},
    _c[StatusPermission.Edit] = 3,
    _c[StatusPermission.View] = 2,
    _c[StatusPermission.Hide] = 1,
    _c);
/** The most-restrictive of the given permissions (Hide < View < Edit). */
export var lowestPermission = function () {
    var perms = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        perms[_i] = arguments[_i];
    }
    return perms.reduce(function (lowest, perm) { return (STATUS_PERMISSION_PRIORITY[perm] < STATUS_PERMISSION_PRIORITY[lowest] ? perm : lowest); }, StatusPermission.Edit);
};
export var Language;
(function (Language) {
    Language["EN"] = "en";
    Language["FR"] = "fr";
})(Language || (Language = {}));
export var LocaleCode;
(function (LocaleCode) {
    LocaleCode["EN_US"] = "en-US";
    LocaleCode["FR_FR"] = "fr-FR";
})(LocaleCode || (LocaleCode = {}));
export var getWorktime = function () { return [
    { name: t('queue.form.queueType.nonDeferrable', { ns: 'wizard' }), id: Worktime.NonDeferrable },
    { name: t('queue.form.queueType.deferrable', { ns: 'wizard' }), id: Worktime.Deferrable },
]; };
export var getLicenseType = function (versionId) {
    var list = [
        { name: t('licenseTypeOption.superadmin', { ns: 'manageUser' }), id: Role.Superadmin },
        { name: t('licenseTypeOption.admin', { ns: 'manageUser' }), id: Role.Admin },
        { name: t('licenseTypeOption.user', { ns: 'manageUser' }), id: Role.User },
    ];
    if (versionId !== Role.Superadmin) {
        return list.filter(function (opt) { return opt.id !== Role.Superadmin; });
    }
    return list;
};
export var ExportLogType;
(function (ExportLogType) {
    ExportLogType[ExportLogType["PlatformAdministration"] = 1] = "PlatformAdministration";
    ExportLogType[ExportLogType["UserAdministration"] = 2] = "UserAdministration";
})(ExportLogType || (ExportLogType = {}));
export var getExportLogType = function () { return [
    { name: t('exportLogTypeOption.platform', { ns: 'manageUser' }), id: ExportLogType.PlatformAdministration },
    { name: t('exportLogTypeOption.user', { ns: 'manageUser' }), id: ExportLogType.UserAdministration },
]; };
export var OrgShrinkageFactorType;
(function (OrgShrinkageFactorType) {
    OrgShrinkageFactorType["Planned"] = "planned";
    OrgShrinkageFactorType["Unplanned"] = "unplanned";
})(OrgShrinkageFactorType || (OrgShrinkageFactorType = {}));
export var ShrinkageCategory;
(function (ShrinkageCategory) {
    ShrinkageCategory["InOffice"] = "in_office";
    ShrinkageCategory["OutOfOffice"] = "out_of_office";
})(ShrinkageCategory || (ShrinkageCategory = {}));
